import {startVideoStream} from "./broadcast/countdown";
import {getEncryptedIdForBroadcaster} from "./broadcast_util";
import {vuepayAlert} from "./utility";
import OT from '@opentok/client';
import NetworkTest from 'opentok-network-test-js';
import {TOKBOX_APIKEY} from "./constants";

export const checkIfCreateBroadcast = (props) => {
    return (
        props.hasOwnProperty("broadcast") &&
        props.broadcast.hasOwnProperty("payload") &&
        props.broadcast.payload !== null
    )
}

export const checkIfCreatePrivateBroadcast = (props) => {
    return (
        props.hasOwnProperty("broadcast") &&
        props.broadcast.hasOwnProperty("private_broadcast_payload") &&
        props.broadcast.private_broadcast_payload !== null
    )
}

export const testConnectivity = (session_id,token) => {

    console.warn("testConnectivity",{
        session_id,
        token
    });


    const otNetworkTest = new NetworkTest(OT, {
        apiKey: TOKBOX_APIKEY, // Add the API key for your OpenTok project here.
        sessionId: "1_MX40NjI3NzM1Mn5-MTU2MzQyNjkzNDA0Mn5YbkVqMEYzSndBQ0dBTzEwQXlDd0lOZGR-QX4",
        token: "T1==cGFydG5lcl9pZD00NjI3NzM1MiZzaWc9OWJiNDRlMzBhZTYxZTEzNzBkOGU0ZTMwNDQ1ODE4MjIxNDM0MjJjODpzZXNzaW9uX2lkPTFfTVg0ME5qSTNOek0xTW41LU1UVTJNelF5Tmprek5EQTBNbjVZYmtWcU1FWXpTbmRCUTBkQlR6RXdRWGxEZDBsT1pHUi1RWDQmY3JlYXRlX3RpbWU9MTU2MzQyNjkzNCZyb2xlPW1vZGVyYXRvciZub25jZT0xNTYzNDI2OTM0LjA4MzEyNjkyMzkzODMmZXhwaXJlX3RpbWU9MTU2MzUxMzMzMyZjb25uZWN0aW9uX2RhdGE9YnJvYWRjYXN0ZXJfaWQlM0QyMCUyQ3VzZXJfaWQlM0Q0JTJDdXNlcl9hcGlfaWQlM0Q3OTc1MDMyNi1iN2Y2LTRkZWQtYTk3YS01YjVkMTNjNDYyNGYlMkN1c2VybmFtZSUzRHNhZ2FyZCUyQ3Byb2ZpbGVfcGljJTNEaHR0cHMlM0ElMkYlMkZzMy5ldS13ZXN0LTIuYW1hem9uYXdzLmNvbSUyRmFzc2V0cy5jaGF0MmZhbnMuY29tJTJGcHJvZHVjdGlvbiUyRjE1NjMzNDU1NDEtYmxvYiUyQ3R5cGUlM0Ricm9hZGNhc3Rlcg=="
    });


    otNetworkTest.testConnectivity().then((results) => {
        //console.log('OpenTok connectivity test results', results);
        //console.log(results.success);

        if (results.success) {
            otNetworkTest.testQuality(function updateCallback(stats) {
                //console.log('intermediate testQuality stats', stats);
            }).then((results) => {
                // This function is called when the quality test is completed.
                //console.log('OpenTok quality results', results);
                let publisherSettings = {};
                if (results.video.reason) {
                    //console.log('Video not supported:', results.video.reason);
                    publisherSettings.videoSource = null; // audio-only
                } else {
                    publisherSettings.frameRate = results.video.recommendedFrameRate;
                    publisherSettings.resolution = results.video.recommendedResolution;
                }
                if (!results.audio.supported) {
                    //console.log('Audio not supported:', results.audio.reason);
                    publisherSettings.audioSource = null;
                    // video-only, but you probably don't want this -- notify the user?
                }

                // Publish to the "real" session, using the publisherSettings object.
                if (results.video.packetLossRatio > 0.03) {
                    vuepayAlert("error", "Poor connectivity...We recommend a good internet connection to maintain a stable video connection with your viewers.");
                } else {
                    //console.log("Network test went ok, navigating to broadcast screen.")
                }

            }).catch((error) => {
                vuepayAlert("error", "Broadcasting error. Please try again later.");
                //console.log('OpenTok quality test error', error);
            });
        }
        else {
            vuepayAlert("error", "Poor connectivity...We recommend a good internet connection to maintain a stable video connection with your viewers.");
        }

    }).catch(function (error) {
        vuepayAlert("error", "Connectivity error. Please try again.");
        //console.log('OpenTok connectivity test error', error);
    });
}